<template>
  <div style="width: 100vw; height: 100vh">
    <div class="logo">
      <img src="/space/images/logo.svg" alt="" />
    </div>
    <div class="leftBottom">2022-2032 © All Right Reserved by WANOS</div>
    <div class="rightTop">
      <div class="tip" v-if="tipBool && tip.title">
        <div class="tip-title">
          <img src="/space/images/tipIcon.svg" alt="" />{{ tip.title }}
        </div>
        <div class="tip-content">
          {{ tip.address }}
        </div>
      </div>
    </div>
    <div class="rightBottom">
      <div class="button" @click="onClickSetting">
        <img src="/space/images/setIcon.svg" alt="" />
        设置
      </div>
    </div>
    <div class="map toTop" @keydown="press" @keyup="release">
      <canvas id="test" :width="width" :height="height"
        >您的浏览器不支持canvas，请升级</canvas
      >
      <Audio3D
        v-if="onLoadBool"
        ref="Audio3D"
        :audioList="audioList"
        :audioXYByMy="audioXYByMy"
        :canvas="canvas"
        :sceneType="tip.sceneType"
        :begin="begin"
      ></Audio3D>
      <Dialog
        v-if="dialogBool && !isSafari"
        @close="dialogBool = false"
        @begin="startPlay"
        @test="dialog2Bool = true"
      />
      <Dialog2 v-if="dialog2Bool" @close="dialog2Bool = false" />
    </div>
  </div>
</template>

<script>
import resize from "../utils/mixins/resize.js";
import Audio3D from "./Audio3D.vue";
import Dialog from "./dialog.vue";
import Dialog2 from "./dialog2.vue";
import { mapState, mapMutations } from "vuex";

var t = 0;

export default {
  mixins: [resize], //和data同级
  components: {
    Audio3D,
    Dialog,
    Dialog2,
  },
  props: ["bgImg", "mapData", "onLoadBool"],
  data() {
    return {
      tipBool: false,
      tip: {
        title: "",
        address: "",
        sceneType: "",
      },
      isBegin: false,
      dialogBool: true,
      dialog2Bool: false,
      value: "2",
      audioOptions: [
        {
          value: "1",
          label: "默认设备",
        },
        {
          value: "2",
          label: "使用耳机",
        },
      ],
      audioList: [],
      bgClassNameList: [
        "toRight",
        "toRightBottom",
        "toBottom",
        "toLeftBottom",
        "toLeft",
        "toLeftTop",
        "toTop",
        "toRightTop",
      ],
      width:
        document.documentElement.clientWidth > 1440
          ? document.documentElement.clientWidth
          : 1440,
      height:
        document.documentElement.clientHeight > 809
          ? document.documentElement.clientHeight
          : 809,
      ctx: null,
      canvas: null,
      img: null,
      imgX: 0,
      imgY: 0,
      imgScale: 1,
      imgScale2: 1,
      imgScale3: 0.5, //对那个鼓的svg进行整体缩放
      side_length_data: {},
      imgScaleUp: 1,
      bgPositionX: 0, // 用于移动
      bgPositionY: 0, // 用于移动
      bgPositionZ: 0, // 用于旋转
      lastBgPositionY: 0, // 用于旋转
      lastBgPositionX: 0, // 用于旋转
      startPointX: 0, // 起始位置
      startPointY: 0, // 起始位置
      //创建多个图像对象
      paused: true, // 开始渲染
      lastTime: 0,
      fps: 0, //当前的帧速s率
      //都是不同图像
      qspeed: 450, // 加速
      speed: 250, // 正常速度
      turnSpeed: 1, // 旋转速度
      turnAngle: 0, // 当前角度
      pxByM: 200,
      keyStatus: {
        right: false,
        up: false,
        left: false,
        down: false,
        quick: false,
        turnLeft: false,
        turnRight: false,
      },
      KEY: {
        D: 68,
        W: 87,
        A: 65,
        S: 83,
        Q: 81,
        E: 69,
        RIGHT: 39,
        UP: 38,
        LEFT: 37,
        DOWN: 40,
        QUICK: 16,
      },
      imgTreeList: [],
      lastXY: [],
      cos: 0,
      activeAudioItem: null,
      nowRotateType: {},
      moveBgPositionX: 0,
      moveBgPositionY: 0,
      myXYZ: {},
      audioSize: 1.5,
      begin: [],
      isDrumPlay: true,
    };
  },
  mounted() {
    document.addEventListener("keydown", (e) => {
      this.press(e);
    });
    document.addEventListener("keyup", (e) => {
      this.release(e);
    });
    this.init();
    this.animate();
  },
  watch: {
    isDrumPlay(newVal, oldVal) {
      this.$refs.Audio3D.getIsDrumPlay(newVal);
    },
    keyStatus: {
      handler() {
        this.paused = !(
          this.keyStatus.right ||
          this.keyStatus.left ||
          this.keyStatus.down ||
          this.keyStatus.up ||
          this.keyStatus.turnLeft ||
          this.keyStatus.turnRight
        );
      },
      deep: true,
    },
    paused() {},
    imgScale() {
      this.draw();
    },
    tip: {
      handler() {
        this.tipBool = true;
      },
      deep: true,
    },
  },
  computed: {
    // 获取音频相对于当前人物的坐标， 人物为0，0点
    audioXYByMy() {
      let x = 0;
      let y = 0;
      let z = 0; // 0 最高 1
      let audioXYZList = [];
      this.audioList.forEach((item) => {
        if (item.type == 2 || item.type == 3 || item.type == 4) {
          // 多声道
          // x = ((item.left - this.myXY.x) * 2) / this.canvas.width;
          // y = -(((item.top - this.myXY.y) * 2) / this.canvas.height);
          // 双耳
          x = -(item.left - this.myXY.x) / this.pxByM;
          y = -(item.top - this.myXY.y) / this.pxByM;
          z = item.height;
          // console.log(
          // 	"音源位置 相对于地图中心 单位像素",
          // 	item.left - this.img.width / 2,
          // 	-(item.top - this.img.width / 2)
          // );

          const w = this.canvas.width / 2;
          const h = this.canvas.height / 2;
          let myX = 0;
          let myY = 0;
          myX = (-this.moveBgPositionX || -this.bgPositionX) + w;
          myY = (-this.moveBgPositionY || -this.bgPositionY) + h;
          /*console.log("音源%d位置 绝对像素: %d, %d", item.id, item.left, item.top);
						console.log("人物位置 绝对像素: %d, %d", myX, myY)
						console.log("音源%d位置 相对像素: %d, %d", item.id, item.left - myX, -(item.top - myY));
						console.log("音源%d位置 相对距离: %d, %d", item.id, x, y);*/

          // console.log(x, y, "音源相对于人物坐标 单位米");
          audioXYZList.push({
            ...this.getRotatePoint(x, y, 0, 0, this.turnAngle),
            z,
            id: item.id,
          });
          // console.log(item.id);
        }
      });
      return audioXYZList;
    },
    // 动态输出人物相对于地图的精确位置
    myXY() {
      const w = this.canvas.width / 2;
      const h = this.canvas.height / 2;
      let myX = 0;
      let myY = 0;
      myX = (-this.moveBgPositionX || -this.bgPositionX) + w;
      myY = (-this.moveBgPositionY || -this.bgPositionY) + h;
      if (!this.paused) {
        // console.log('人物位置', myX, myY)
        // console.log("人物朝向角度", this.turnAngle);
        // console.log("当前人物相对于地图中心的位置 单位m", {
        // 	x: (myX - this.img.width / 2) / this.pxByM,
        // 	y: -(myY - this.img.height / 2) / this.pxByM,
        // });
      }
      // console.log("当前人物相对于地图中心的位置 单位m", {
      //   x: (myX - this.img.width / 2) / this.pxByM,
      //   y: -(myY - this.img.height / 2) / this.pxByM,
      // });
      this.getTip(myX, myY);
      return { x: myX, y: myY };
    },

    // 动态获取当前浏览器是否为Safari
    ...mapState(["isSafari"]),
  },
  methods: {
    async init() {
      setInterval(() => {
        if (this.audioSize >= 1) {
          this.audioSize -= 0.1;
        } else if (this.audioSize <= 1) {
          this.audioSize = 1.5;
        }
      }, 100);
      let mapDataList = this.mapData.map((item, index) => {
        return {
          ...item,
          id: index,
        };
      });
      this.audioList = mapDataList.filter(
        (item) => item.type === 2 || item.type === 3 || item.type === 4
      );
      this.width =
        document.documentElement.clientWidth > 1440
          ? document.documentElement.clientWidth
          : 1440;
      this.height =
        document.documentElement.clientHeight > 809
          ? document.documentElement.clientHeight
          : 809;
      this.canvas = document.querySelector("#test");
      if (this.canvas.getContext) {
        this.ctx = this.canvas.getContext("2d");
        this.ctx.width = this.width;
        this.ctx.height = this.height;
        this.bgPositionX = -950; //改变画面初始位置，同时是箭头的初始位置
        this.bgPositionY = -450;
        this.img = new Image();
        this.myImg = new Image();
        this.myBgImg = new Image();
        this.img.src = "/space/images/bgAll_k.jpg";
        this.myImg.src = "/space/images/my.svg";
        this.myBgImg.src = "/space/images/mybg.svg";
        this.img.onload = () => {
          // 8400 4000 1400 707
        };
        this.imgTreeList = [];
        for (var item in mapDataList) {
          if (mapDataList[item].src) {
            await this.getImage(mapDataList[item], mapDataList);
          }
        }
        this.$emit("initAudio");
        this.canvas.onmousedown = (e) => {
          // demo------------------------------------------------
          e = window.event;
          const w = this.canvas.width / 2;
          const h = this.canvas.height / 2;
          var clickX = e.clientX;
          var clickY = e.clientY;
          // // 获取按下位置在地图的相对坐标
          const rotateClick = this.getRotatePoint(
            clickX,
            clickY,
            w,
            h,
            360 - this.turnAngle
          );
          const rotateClickX =
            rotateClick.x + (-this.moveBgPositionX || -this.bgPositionX);
          const rotateClickY =
            rotateClick.y + (-this.moveBgPositionY || -this.bgPositionY);
          // console.log(
          // 	rotateClick.x,
          // 	-this.moveBgPositionX || -this.bgPositionX
          // );
          // console.log("当前点击位置相对于地图中心的相对坐标", {
          //   x: rotateClickX - this.img.width / 2,
          //   y: -(rotateClickY - this.img.height / 2),
          // });
          // 关键log,定义音源摆放的坐标
          // console.log("当前点击位置相对于地图左上角的相对坐标", {
          //   x: rotateClickX,
          //   y: rotateClickY,
          // });
          const x =
            this.imgScale2 === 1
              ? rotateClickX
              : ((this.canvas.width / this.imgScale2 - this.canvas.width) / 2 +
                  (rotateClickX + this.bgPositionX)) *
                  this.imgScale2 -
                this.bgPositionX;
          const y =
            this.imgScale2 === 1
              ? rotateClickY
              : ((this.canvas.height / this.imgScale2 - this.canvas.height) /
                  2 +
                  (rotateClickY + this.bgPositionY)) *
                  this.imgScale2 -
                this.bgPositionY;

          // console.log(
          // 	"加进来",
          // 	rotateClick.x,
          // 	((this.canvas.width / this.imgScale2 -
          // 		this.canvas.width) /
          // 		2) *
          // 		this.imgScale2,
          // 	rotateClick.y,
          // 	((this.canvas.height / this.imgScale2 -
          // 		this.canvas.height) /
          // 		2) *
          // 		this.imgScale2,
          // 	this.bgPositionY
          // );
          this.imgTreeList.forEach((item, index) => {
            if (item.type !== 2) return;
            const isClick = this.getIsMove(
              {
                x: rotateClickX,
                y: rotateClickY,
              },
              { x: item.left, y: item.top }
            );
            //     console.log(
            //     	isClick,
            //     	{
            //     		x: rotateClickX - (this.canvas.width/this.imgScale2-this.canvas.width)/2*this.imgScale2,
            //     		y: rotateClickY - (this.canvas.height/this.imgScale2-this.canvas.height)/2*this.imgScale2,
            //     	},
            // {ax:(this.canvas.width/this.imgScale2-this.canvas.width)/2*this.imgScale2,ay:(this.canvas.height/this.imgScale2-this.canvas.height)/2*this.imgScale2},
            //     	{ x, y },
            //     	{ x: item.left, y: item.top },
            // this.imgScale2
            //     );
            if (isClick) {
              if (this.nowDate && Date.now() - this.nowDate < 200) {
                // 双击
                if (this.begin.includes(item.id)) {
                  this.begin = [];
                } else {
                  this.begin.push(item.id);
                }
                this.isDrumPlay = !this.isDrumPlay;
              } else {
                this.activeAudioItem = item.id;
              }
              this.nowDate = Date.now();
            }
          });
        };
        this.canvas.onmousemove = (e) => {
          const w = this.canvas.width / 2;
          const h = this.canvas.height / 2;
          var moveX = e.clientX;
          var moveY = e.clientY;
          const rotateMove = this.getRotatePoint(
            moveX,
            moveY,
            w,
            h,
            360 - this.turnAngle
          );
          const rotateMoveX =
            rotateMove.x + (-this.moveBgPositionX || -this.bgPositionX);
          const rotateMoveY =
            rotateMove.y + (-this.moveBgPositionY || -this.bgPositionY);
          let left = rotateMoveX - 25; //鼓在移动时，保证鼠标箭头放置在鼓的正中心
          let top = rotateMoveY - 25;
          let { x, y } = this.getRotatePoint(
            left,
            top,
            this.canvas.width / 2,
            this.canvas.height / 2,
            this.turnAngle
          );
          if (this.activeAudioItem !== null) {
            this.imgTreeList.forEach((item, index) => {
              if (item.id === this.activeAudioItem) {
                this.imgTreeList[index].left = left;
                this.imgTreeList[index].top = top;
              }
            });

            this.audioList.forEach((item, index) => {
              if (item.id === this.activeAudioItem) {
                this.audioList[index].left = left;
                this.audioList[index].top = top;
              }
            });
          }
        };
        this.canvas.onmouseup = (e) => {
          this.activeAudioItem = null;
        };
      }
    },
    getImage(imgData, mapDataList) {
      return new Promise(
        (resolve, reject) => {
          try {
            const { path, left, top, type, id } = imgData;
            let img = new Image();
            img.src = imgData.src;
            img.onload = () => {
              this.begin.push(id);
              this.imgTreeList.push({
                img,
                left,
                top,
                type,
                id,
              });
              if (this.imgTreeList.length === mapDataList.length) {
                this.imgScaleWheel();
                this.draw();
              }
              resolve();
            };
          } catch (err) {
            console.log("报错了", err);
          }
        },
        (err) => {
          reject();
        }
      );
    },
    // 每个场景音源范围限定及场景描述文本
    getTip(x, y) {
      let diff_x_val = 504;
      let tipXY = [
        //
        {
          x: 1836 + diff_x_val,
          y: 420,
          move: 310,
          title: "游乐场，这里是快乐星球",
          tip: "全世界都在催你长大，只有游乐场不会。",
          type: "1",
        },
        {
          x: 907 + diff_x_val,
          y: 626,
          move: 309,
          title: "草地派对，沟通畅聊",
          tip: "沉浸且有方位感的聊天，让聚会极具氛围感。",
          type: "2",
        },
        {
          x: 2170 + diff_x_val,
          y: 1421,
          move: 497,
          title: "轻松爵士乐，入耳怦然心动",
          tip: "在这里体验沉浸式音乐，跟着节拍舞动。",
          type: "3",
        },

        {
          x: 3921 + diff_x_val,
          y: 950,
          move: 1200,
          title: "海边漫步，享受静谧时光",
          tip: "自在海边行走，海风吹过海浪席卷而来，海鸥经过发出鸣叫，听着海浪的声音，全世界都安静下来了。",
          type: "4",
        },
        {
          x: 2848 + diff_x_val,
          y: 342,
          move: 500,
          title: "海边漫步，享受静谧时光",
          tip: "自在海边行走，海风吹过海浪席卷而来，海鸥经过发出鸣叫，听着海浪的声音，全世界都安静下来了。",
          type: "4",
        },
        {
          x: 2975 + diff_x_val,
          y: 1114,
          move: 350,
          title: "海边漫步，享受静谧时光",
          tip: "自在海边行走，海风吹过海浪席卷而来，海鸥经过发出鸣叫，听着海浪的声音，全世界都安静下来了。",
          type: "4",
        },
        {
          x: 3057 + diff_x_val,
          y: 1633,
          move: 400,
          title: "海边漫步，享受静谧时光",
          tip: "自在海边行走，海风吹过海浪席卷而来，海鸥经过发出鸣叫，听着海浪的声音，全世界都安静下来了。",
          type: "4",
        },

        {
          x: 700 + diff_x_val,
          y: 1400,
          move: 500,
          title: "原始森林，寻找心之所向",
          tip: "微风拂过，树叶沙沙作响。天空鸟儿盘旋，声音自然灵动。听！其他动物也在发出声音。",
          type: "5",
        },
        {
          x: 1044 + diff_x_val,
          y: 1086,
          move: 160,
          title: "原始森林，寻找心之所向",
          tip: "微风拂过，树叶沙沙作响。天空鸟儿盘旋，声音自然灵动。听！其他动物也在发出声音。",
          type: "5",
        },
        {
          x: 1016 + diff_x_val,
          y: 1174,
          move: 200,
          title: "原始森林，寻找心之所向",
          tip: "微风拂过，树叶沙沙作响。天空鸟儿盘旋，声音自然灵动。听！其他动物也在发出声音。",
          type: "5",
        },
        {
          x: 474 + diff_x_val,
          y: 868,
          move: 150,
          title: "原始森林，寻找心之所向",
          tip: "微风拂过，树叶沙沙作响。天空鸟儿盘旋，声音自然灵动。听！其他动物也在发出声音。",
          type: "5",
        },
        {
          //直升机螺旋桨
          x: 585,
          y: 1229,
          move: 400,
          title: "嗡嗡嗡，直升机低空游",
          tip: "时而盘旋爬高，时而俯冲下来，犹如一只掠过海面的鸥鸟。",
          type: "6",
        },
        // {
        //   //直升机螺旋桨
        //   x: 585,
        //   y: 1229,
        //   move: 400,
        //   tip: "时而盘旋爬高,时而俯冲下来,犹如一只掠过海面的鸥鸟",
        //   title: "嗡嗡嗡,直升机低空游",
        //   type: "7",
        // },
      ];
      // sceneType 1 游乐场 2 会议 3 音乐场 4 海边 5 森林 6 停机坪
      let bool = false;
      tipXY.forEach((item) => {
        if (this.getIsMove({ x, y }, item, item.move)) {
          bool = true;
          if (this.address !== item.tip) {
            this.tip = {
              address: item.tip,
              title: item.title,
              sceneType: item.type,
            };
          }
        }
      });
      if (!bool) {
        this.tipBool = false;
        this.tip = {
          title: "",
          address: "",
          sceneType: "",
        };
      }
    },
    drawMyRotate() {
      this.ctx.restore(); //恢复状态
      this.ctx.save(); //保存状态
      this.ctx.translate(this.canvas.width / 2, this.canvas.height / 2); //设置画布上的(0,0)位置，也就是旋转的中心点
      this.ctx.rotate(0 * (Math.PI / 180));
      this.ctx.translate(this.bgPositionX, this.bgPositionY); //设置画布上的(0,0)位置，也就是旋转的中心点
      this.drawMy(); //把图片绘制在旋转的中心点，
      this.ctx.restore(); //恢复状态
      // this.drawTreeRotate();
    },
    drawTreeRotate(x, y) {
      this.ctx.save(); //保存状态
      this.ctx.translate(this.canvas.width / 2, this.canvas.height / 2); //设置画布上的(0,0)位置，也就是旋转的中心点
      this.ctx.rotate(this.turnAngle * (Math.PI / 180));
      this.ctx.translate(
        (x || this.bgPositionX) * this.imgScale2,
        (y || this.bgPositionY) * this.imgScale2
      ); //设置画布上的(0,0)位置，也就是旋转的中心点
      this.ctx.scale(this.imgScale2, this.imgScale2);
      this.drawTree(); //把图片绘制在旋转的中心点，
      this.ctx.restore(); //恢复状态
      this.ctx.save(); //保存状态
    },
    drawTree() {
      this.imgTreeList.forEach(({ img, left, top, type }) => {
        if (!type) {
          this.ctx.drawImage(
            img,
            left - this.canvas.width / 2,
            top - this.canvas.height / 2,
            img.width,
            img.height
          );
        }
        if (left == 9999 && top == 9999) {
          if (this.ctx.width == 1440) {
            this.ctx.translate(-157, 780);
          } else {
            let valWidth = this.ctx.width - 1440;
            let valHeight = this.ctx.height - 809;
            this.ctx.translate(-157 - valWidth * 0.5, 780 - valHeight * 0.5);
          }
          this.ctx.rotate((this.audioSize * Math.PI * 300) / 180);
          this.ctx.drawImage(img, -img.width / 2, -img.height / 2);
        }
      });
    },
    drawMy() {
      // 此处绘制的是箭头
      this.ctx.drawImage(
        this.myBgImg,
        -this.bgPositionX - 50 * this.imgScale3,
        -this.bgPositionY - 50 * this.imgScale3,
        100 * this.imgScale3,
        100 * this.imgScale3
      );
      this.ctx.drawImage(
        this.myImg,
        -this.bgPositionX - 25 * this.imgScale3,
        -this.bgPositionY - 25 * this.imgScale3,
        50 * this.imgScale3,
        50 * this.imgScale3
      );
    },
    drawOther() {
      this.imgTreeList.forEach(({ img, left, top, type, id }) => {
        if (type !== 1 && type !== 2 && type !== 4) return;
        if (type === 2 || type === 4) {
        } else {
          this.ctx.drawImage(
            img,
            left * this.imgScale - this.canvas.width / 2,
            top * this.imgScale - this.canvas.height / 2,
            img.width * this.imgScale,
            img.height * this.imgScale
          );
        }
      });
      this.imgTreeList.forEach(({ img, left, top, type, id }) => {
        if (type === 2) {
          // 此处绘制的是鼓
          if (this.begin.includes(id)) {
            this.ctx.drawImage(
              img,
              left * this.imgScale -
                this.canvas.width / 2 -
                (100 * this.imgScale3 * this.audioSize) / 2 +
                50 * this.imgScale3,
              top * this.imgScale -
                this.canvas.height / 2 -
                (100 * this.imgScale3 * this.audioSize) / 2 +
                50 * this.imgScale3,
              100 * this.imgScale3 * this.audioSize,
              100 * this.imgScale3 * this.audioSize
            );
          } else {
            this.ctx.drawImage(
              img,
              left - this.canvas.width / 2,
              top - this.canvas.height / 2,
              100 * this.imgScale3,
              100 * this.imgScale3
            );
          }
        } else if (type === 5) {
          // 绘制直升机运动轨迹
          if (this.ctx.width == 1440) {
            this.ctx.translate(-300, 100);
          } else {
            let valWidth = this.ctx.width - 1440;
            let valHeight = this.ctx.height - 809;
            this.ctx.translate(-300 - valWidth * 0.5, 100 - valHeight * 0.5);
          }
          //起点
          var [x1, y1] = [1200, -500];
          //小球起点
          var [x, y] = [1200, -500];
          //控制点
          var [cx, cy] = [-970, 1200];
          //终点
          var [x2, y2] = [1300, 830];
          // 绘制运动曲线
          this.ctx.beginPath();
          this.ctx.moveTo(1200, -500);
          this.ctx.quadraticCurveTo(cx, cy, x2, y2);
          // this.ctx.stroke();
          this.ctx.closePath();
          /*贝塞尔曲线上点位的控制*/
          x =
            Math.pow(1 - t, 2) * x1 +
            2 * t * (1 - t) * cx +
            Math.pow(t, 2) * x2;
          y =
            Math.pow(1 - t, 2) * y1 +
            2 * t * (1 - t) * cy +
            Math.pow(t, 2) * y2;
          if (x > 1300) {
            t = 0;
            x = 0;
            y = 0;
            return;
          }
          // 画一个运动的球
          this.ctx.beginPath();
          this.ctx.fillStyle = "red";
          this.ctx.arc(x, y, 10, 0, 2 * Math.PI);
          // this.ctx.fill();
          t += 0.0005; //控制动画移动速度
          this.audioList.forEach((item, index) => {
            if (item.sceneType == 6) {
              this.audioList[index].left = x + 419;
              this.audioList[index].top = y + 503;
            }
          });
        }
      });
    },

    //擦除方法
    erase() {
      this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
    },
    rotate(x, y, xm, ym, a) {
      var cos = Math.cos,
        sin = Math.sin,
        a = (a * Math.PI) / 180, // Convert to radians because that is what
        // JavaScript likes

        // Subtract midpoints, so that midpoint is translated to origin
        // and add it in the end again
        xr = (x - xm) * cos(a) - (y - ym) * sin(a) + xm,
        yr = (x - xm) * sin(a) + (y - ym) * cos(a) + ym;

      return [xr, yr];
    },
    draw() {
      // this.ctx.translate(this.img.width / 2, this.img.height / 2);
      // 2.1 设置canvas宽高，旋转90° ，宽高互换
      // this.canvas.width = this.height;
      // this.canvas.height = this.width;
      // // 2.2 画布中心点(也是起始点)平移至中心(0,0)->(x,y)
      // this.ctx.translate(this.canvas.width / 2, this.canvas.height / 2);
      // 2.3 画布旋转90°
      // this.ctx.rotate((270 * Math.PI) / 180);
      // 2.4 绘制图像 图像起始点需偏移负宽高
      // this.ctx.drawImage(
      // 	this.img,
      // 	-this.width / 2,
      // 	-this.height / 2,
      // 	this.img.width,
      // 	this.img.height
      // );

      // this.ctx.save();
      //fps是共用的
      //应该是确定当前图像位置的坐标X
      // 判断按键
      const { right, left, up, down, turnLeft, turnRight } = this.keyStatus;
      let newx = this.bgPositionX;
      let newy = this.bgPositionY;
      const myX = this.myXY.x;
      const myY = this.myXY.y;
      const leftBool = myX < 0;
      const rightBool = myX > this.img.width;
      const topBool = myY < 0;
      const bottomBool = myY > this.img.height;
      const rotateType = this.nowRotateType.rotateType || "上";
      let leftB, rightB, bottomB, topB;
      switch (rotateType) {
        case "上":
          leftB = leftBool;
          rightB = rightBool;
          topB = topBool;
          bottomB = bottomBool;
          break;
        case "右上":
          leftB = leftBool || bottomBool;
          rightB = rightBool || topBool;
          topB = topBool || leftBool;
          bottomB = bottomBool || rightBool;
          break;
        case "右":
          leftB = bottomBool;
          rightB = topBool;
          topB = leftBool;
          bottomB = rightBool;
          break;
        case "右下":
          leftB = bottomBool || rightBool;
          rightB = topBool || leftBool;
          topB = leftBool || bottomBool;
          bottomB = rightBool || topBool;
          break;
        case "下":
          leftB = rightBool;
          rightB = leftBool;
          topB = bottomBool;
          bottomB = topBool;
          break;
        case "左下":
          leftB = rightBool || topBool;
          rightB = leftBool || bottomBool;
          topB = bottomBool || rightBool;
          bottomB = topBool || leftBool;
          break;
        case "左":
          leftB = topBool;
          rightB = bottomBool;
          topB = rightBool;
          bottomB = leftBool;
          break;
        case "左上":
          leftB = topBool || leftBool;
          rightB = bottomBool || rightBool;
          topB = rightBool || topBool;
          bottomB = leftBool || bottomBool;
          break;
      }
      if (left) {
        if (leftB) {
          newx = newx;
        } else {
          newx = newx + this.getSpeed() / this.fps;
        }
      }
      if (right) {
        if (rightB) {
          newx = newx;
        } else {
          newx = newx - this.getSpeed() / this.fps;
        }
      }
      if (up) {
        if (topB) {
          newy = newy;
        } else {
          newy = newy + this.getSpeed() / this.fps;
        }
      }
      if (down) {
        if (bottomB) {
          newy = newy;
        } else {
          newy = newy - this.getSpeed() / this.fps;
        }
      }
      // if(this.listsss) {
      // 	this.listsss.push(newx)
      // 	this.listsss.push(newy)
      // 	this.listsss = this.listsss.sort((a,b) => {
      // 		return a-b
      // 	}).slice(0,3)
      // 	this.listbbb[this.nowRotateType.rotateType] = this.listsss[0]
      // } else {
      // 	this.listsss = [newx,newy]
      // 	this.listbbb= {}
      // }
      if (turnRight) {
        // if(this.turnAngle <= 360) {
        this.turnAngle = this.turnAngle - this.turnSpeed;
        if (this.turnAngle < 0) this.turnAngle = 360;
        // } else {
        // this.turnSpeed = 0
        // }
        this.getTurnAngle();
      }
      if (turnLeft) {
        // if(this.turnAngle <= 0) {
        this.turnAngle = this.turnAngle + this.turnSpeed;
        if (this.turnAngle > 360) this.turnAngle = 0;
        // } else {
        // this.turnSpeed = 0
        // }
        this.getTurnAngle();
      }
      this.bgPositionY = newy;
      this.bgPositionX = newx;
      this.ctx.save();
      const w = this.canvas.width / 2;
      const h = this.canvas.height / 2;

      if (this.turnAngle !== 0) {
        const b = this.getRotatePoint(
          this.lastBgPositionX,
          this.lastBgPositionY,
          0,
          0,
          this.turnAngle
        );
        let movex, movey;
        movex = this.bgPositionX - this.lastX;
        movey = this.bgPositionY - this.lastY;
        this.ctx.translate(
          w + (b.x + movex) * this.imgScale2,
          h + (b.y + movey) * this.imgScale2
        );
        this.ctx.rotate(this.turnAngle * (Math.PI / 180));
        this.ctx.scale(this.imgScale2, this.imgScale2);
        this.ctx.drawImage(this.img, -w, -h);
        this.drawOther();
        this.drawMyRotate();
        const c = this.getRotatePoint(
          b.x + movex,
          b.y + movey,
          0,
          0,
          360 - this.turnAngle
        );
        this.drawTreeRotate(c.x, c.y);
        // this.lastX = this.bgPositionX
        // this.lastY = this.bgPositionY

        this.moveBgPositionX = c.x;
        this.moveBgPositionY = c.y;
        // this.lastBgPositionX = w + b.x +movex
        // this.lastBgPositionY = h + b.y+movey
      } else {
        this.ctx.translate(
          this.bgPositionX * this.imgScale2 + w,
          this.bgPositionY * this.imgScale2 + h
        );
        this.ctx.rotate(this.turnAngle * (Math.PI / 180));
        this.ctx.scale(this.imgScale2, this.imgScale2); //整体缩放背景大图
        this.ctx.drawImage(this.img, -w, -h);
        this.drawOther();
        this.drawMyRotate();

        this.drawTreeRotate();
        this.lastBgPositionY = this.bgPositionY;
        this.lastBgPositionX = this.bgPositionX;
      }
      if (turnLeft || turnRight) {
        this.ctx.translate(w, h);
        this.ctx.rotate(this.turnAngle * (Math.PI / 180));
        this.ctx.scale(this.imgScale2, this.imgScale2);
        this.ctx.translate(
          this.moveBgPositionX || this.bgPositionX,
          this.moveBgPositionY || this.bgPositionY
        );
        this.ctx.drawImage(this.img, -w, -h);
        this.drawOther();
        this.drawMyRotate();

        this.lastBgPositionX = this.moveBgPositionX || this.bgPositionX;
        this.lastBgPositionY = this.moveBgPositionY || this.bgPositionY;
        this.drawTreeRotate(this.lastBgPositionX, this.lastBgPositionY);
        this.lastX = this.bgPositionX;
        this.lastY = this.bgPositionY;
      }
      // this.drawMyRotate();

      this.ctx.restore();
      // this.drawTreeRotate();
    },
    getRotatePoint(targetX, targetY, centerX, centerY, angle) {
      const rotation = (angle * Math.PI) / 180;
      const x =
        (targetX - centerX) * Math.cos(rotation) -
        (targetY - centerY) * Math.sin(rotation) +
        centerX;
      const y =
        (targetX - centerX) * Math.sin(rotation) +
        (targetY - centerY) * Math.cos(rotation) +
        centerY;
      return { x, y };
    },
    //计算当前的FPS,
    calculateFps(now) {
      //1000毫秒除以距离上一次计算FPS的时间意思是，或者距离上一次绘制图像
      //这段时间里面执行了多少次
      //除以1000是因为now和lastTime都是以毫秒为单位的
      //反正fps就是一秒内能够执行绘制多少次
      var fps = 1000 / (now - this.lastTime);
      this.lastTime = now;
      return fps;
    },
    animate(now) {
      if (now === undefined) {
        now = +new Date();
      }
      this.fps = this.calculateFps(now);
      // if (!this.paused || this.activeAudioItem !== null) {
      //原例子中是用兼容的手法实现requestAnimationFrame，所以需要erase
      this.erase();
      this.draw();

      // }
      // console.log(this.audioSize);
      // 获取紫色音源坐标
      // 获取朝向
      // this.getTurnAngle();
      //以最适合的速度执行animate中的内容，这个比较适合动画的处理，类似于setTimeout
      requestAnimationFrame(this.animate);
    },
    // 获取朝向
    getTurnAngle() {
      let cos = 0;
      let rotateType = "上";
      if (this.turnAngle < 90 && this.turnAngle >= 0) {
        cos = 90 - this.turnAngle;
        rotateType = cos !== 0 ? "右上" : "右";
      }
      if (this.turnAngle < 180 && this.turnAngle >= 90) {
        cos = 180 - this.turnAngle;
        rotateType = cos !== 0 ? "右下" : "下";
      }
      if (this.turnAngle < 270 && this.turnAngle >= 180) {
        cos = 270 - this.turnAngle;
        rotateType = cos !== 0 ? "左下" : "左";
      }
      if (this.turnAngle < 360 && this.turnAngle >= 270) {
        cos = 360 - this.turnAngle;
        rotateType = cos !== 0 ? "左上" : "上";
      }
      this.nowRotateType = {
        rotateType,
        cos,
      };
    },
    // 勾股定理
    // 已知直角三角形的斜角度数和斜边长度，求邻边和对边的长度
    side_length(angle, long) {
      //获得弧度

      var radian = ((2 * Math.PI) / 360) * angle;
      return {
        y: Math.cos(radian) * long, //斜角邻边长度 x
        x: Math.sin(radian) * long, //斜角对边长度  y
      };
    },
    // bevel(直角边长,斜边长)
    // 已知直角三角形的一直角边长度和斜边长度，求之间的角度
    bevel(straight, oblique) {
      const sinOfAngleX = straight / oblique;
      const angle = Math.round((Math.asin(sinOfAngleX) * 180) / Math.PI);
      return angle;
    },
    // 根据当前xy获取旋转之后的xy
    getRotateXY({ x, y }) {
      let obj = {};
      let len;
      let angleOne; // y与斜边角度
      let angleTwo; // turnAngle - y与斜边角度
      let w = this.canvas.width / 2;
      let h = this.canvas.height / 2;
      switch (this.nowRotateType.rotateType) {
        case "上":
          obj = { x, y };
          break;
        case "右上":
          // step1 计算 xy斜边长
          len = Math.sqrt(
            Math.abs(x - w) * Math.abs(x - w) +
              Math.abs(h - y) * Math.abs(h - y)
          );
          // step2 计算 y与斜边角度
          angleOne = this.bevel(h - y, len);
          // step3 根据斜边和所剩角度计算 新 xy
          angleTwo = 90 - (this.turnAngle - angleOne);
          obj = this.side_length(angleTwo, len);
          obj.x = obj.x + w;
          obj.y = obj.y + h;
          break;
        case "右":
          break;
        case "右下":
          break;
        case "下":
          break;
        case "左下":
          break;
        case "左":
          break;
        case "左上":
          break;
      }
      return obj;
    },
    // 键盘按下后事件
    press(event) {
      const code = event.keyCode;
      switch (code) {
        // case this.KEY.RIGHT:
        case this.KEY.D:
          this.keyStatus.right = true;
          break;
        case this.KEY.UP:
        case this.KEY.W:
          this.keyStatus.up = true;
          break;
        // case this.KEY.LEFT:
        case this.KEY.A:
          this.keyStatus.left = true;
          break;
        case this.KEY.DOWN:
        case this.KEY.S:
          this.keyStatus.down = true;
          break;
        case this.KEY.QUICK:
          this.keyStatus.quick = true;
          break;
        case this.KEY.Q:
        case this.KEY.LEFT: //
          this.keyStatus.turnLeft = true;
          break;
        case this.KEY.E:
        case this.KEY.RIGHT: //
          this.keyStatus.turnRight = true;
          break;
      }
    },
    // 键盘抬起后事件
    release(event) {
      const code = event.keyCode;
      switch (code) {
        // case this.KEY.RIGHT:
        case this.KEY.D:
          this.keyStatus.right = false;
          break;

        case this.KEY.UP:
        case this.KEY.W:
          this.keyStatus.up = false;
          break;

        // case this.KEY.LEFT:
        case this.KEY.A:
          this.keyStatus.left = false;
          break;

        case this.KEY.DOWN:
        case this.KEY.S:
          this.keyStatus.down = false;
          break;
        case this.KEY.QUICK:
          this.keyStatus.quick = false;
          break;
        case this.KEY.Q:
        case this.KEY.LEFT: //
          this.keyStatus.turnLeft = false;
          break;
        case this.KEY.E:
        case this.KEY.RIGHT: //
          this.keyStatus.turnRight = false;

          break;
      }
    },
    getSpeed() {
      return this.keyStatus.quick ? this.qspeed : this.speed;
    },
    getIsMove(a, b, move = 120) {
      // 勾股定理获取点与圆心的距离
      return Math.sqrt(Math.pow(a.x - b.x, 2) + Math.pow(a.y - b.y, 2)) < move;
    },
    onClickSetting() {
      this.$refs.Audio3D.pausePlay();
      this.dialogBool = true;
    },
    startPlay() {
      this.$refs.Audio3D.startPlayPre();

      this.$nextTick(() => {
        this.bool = false;
        if (!this.isBegin) {
          setTimeout(() => {
            // this.startPlay();
            // console.log("begin");
            this.isBegin = true;
            this.bool = false;
          }, 100);
        }
      });
    },
  },
};
</script>

<style lang="scss">
* {
  margin: 0;
  padding: 0;
}
// 从下向上
// 270 rgb(125, 199, 237)
.toTop {
  // background-image: linear-gradient(to top, #adcb59, #adcb59, #adcb59);
  background: #c3d95c;
}

// 90
.toBottom {
  // background-image: linear-gradient(
  //   to bottom,
  //   rgb(178, 202, 104),
  //   rgb(178, 202, 104),
  //   rgb(125, 199, 237)
  // );
  background: #c3d95c;
}

// 0
.toRight {
  // background-image: linear-gradient(
  //   to right,
  //   rgb(178, 202, 104),
  //   rgb(178, 202, 104),
  //   rgb(125, 199, 237)
  // );
  background: #c3d95c;
}

// 180
.toLeft {
  // background-image: linear-gradient(
  //   to left,
  //   rgb(178, 202, 104),
  //   rgb(178, 202, 104),
  //   rgb(125, 199, 237)
  // );
  background: #c3d95c;
}

// 135
.toLeftBottom {
  // background-image: linear-gradient(
  //   to left bottom,
  //   rgb(178, 202, 104),
  //   rgb(178, 202, 104),
  //   rgb(125, 199, 237)
  // );
  background: #c3d95c;
}

// 225
.toLeftTop {
  // background-image: linear-gradient(
  //   to left top,
  //   rgb(178, 202, 104),
  //   rgb(178, 202, 104),
  //   rgb(125, 199, 237)
  // );
  background: #c3d95c;
}

// 45
.toRightBottom {
  // background-image: linear-gradient(
  //   to right bottom,
  //   rgb(178, 202, 104),
  //   rgb(178, 202, 104),
  //   rgb(125, 199, 237)
  // );
  background: #c3d95c;
}

// 315
.toRightTop {
  // background-image: linear-gradient(
  //   to right top,
  //   rgb(178, 202, 104),
  //   rgb(178, 202, 104),
  //   rgb(125, 199, 237)
  // );
  background: #c3d95c;
}

.map {
  margin: 0;
  width: 100%;
  height: 100%;
  padding: 0;
  font-family: "Open Sans", sans-serif;
  font-weight: lighter;
  color: white;
  z-index: -1;
  overflow-y: hidden;
  overflow-x: hidden;
  width: 100%;
  height: 100%;

  canvas {
    width: 100%;
    display: block;
  }
}

.mask-dialog {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  color: #bbc8e5;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99999;
  .dialog-box {
    width: 800px;
    height: 500px;
    background: #21242d;
    .dialog-title {
      background: #2b2f37;
      padding: 0 20px;
      line-height: 50px;
      display: flex;
      justify-content: space-between;
      color: #bbc8e5;
    }
    .dialog-content {
      display: flex;
      padding: 50px 20px;
      .left {
        width: 180px;
        padding: 40px;
        border: 1px solid #bbc8e5;
        border-radius: 104px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .info {
          color: #bbc8e5;
          text-align: center;
          line-height: 60px;
        }
        .action {
          display: flex;
          flex-direction: column;
          align-items: center;
        }
      }
      .center {
        flex: 1;
        img {
          width: 100%;
        }
      }
      .right {
        width: 180px;
        flex: 1;
        padding: 40px;
        border: 1px solid #bbc8e5;
        border-radius: 104px;
        display: flex;
        justify-content: center;
        .info {
          color: #bbc8e5;
          line-height: 40px;
          text-align: center;
        }
        img {
        }
      }
    }
    .dialog-action {
      padding: 0 20px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }
  }
}
.logo {
  position: fixed;
  top: 20px;
  left: 20px;
  width: 180px;
  img {
    width: 100%;
  }
}
.leftBottom {
  position: fixed;
  bottom: 20px;
  left: 20px;
  font-family: "PingFang SC";
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 18px;

  color: #ffffff;
}
.rightBottom {
  position: fixed;
  bottom: 20px;
  right: 20px;
  .button {
    height: 38px;
    background: rgba(46, 51, 60, 0.6);
    border-radius: 4px;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 0px 20px;
    gap: 6px;
    color: #fff;
    cursor: pointer;
  }
}
.rightTop {
  position: fixed;
  top: 50px; //20
  right: 20px;
  display: flex;
  flex-direction: column;
  align-items: end;
  .button {
    width: 172px;
    height: 38px;
    background: rgba(46, 51, 60, 0.6);
    border-radius: 4px;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 0px 20px;
    gap: 6px;
    color: #fff;
    cursor: pointer;
  }
  .tip {
    width: 160px;
    margin-top: 20px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 0 20px;
    padding-bottom: 20px;
    background: rgba(255, 255, 255, 0.8);
    border: 1px solid #ffffff;
    box-shadow: 0px 4px 14px rgba(0, 0, 0, 0.1);
    border-radius: 6px;
    .tip-title {
      color: #f7594d;
      font-family: "PingFang SC";
      font-style: normal;
      font-weight: 500;
      font-size: 12px;
      line-height: 40px;
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 6px;
      white-space: nowrap;
    }
    .tip-content {
      font-family: "PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 12px;
      line-height: 18px;
      text-align: left;
      color: #636468;
    }
  }
}
</style>
